import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <div className="border-2 border-[#d4a853]/40 rounded-sm p-8 md:p-12 text-center bg-[#111111] relative overflow-hidden" data-id="element-55">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-60 h-60 bg-[#d4a853]/5 blur-[100px] pointer-events-none" data-id="element-56" />

          <ShieldCheckIcon className="w-14 h-14 text-[#d4a853] mx-auto mb-6 relative z-10" data-id="element-57" />

          <h2 className="font-playfair text-2xl md:text-3xl font-bold mb-6 relative z-10" data-id="element-58">
            7 Días de <span className="text-[#d4a853]" data-id="element-59">Prueba de Fuego</span>
          </h2>

          <p className="text-gray-300 text-base md:text-lg leading-relaxed relative z-10" data-id="element-60">
            Si entras, descargas la bóveda, usas los prompts y sientes que lo
            que creaste no es{' '}
            <span className="text-white font-semibold" data-id="element-61">10 veces mejor</span> que
            lo que tenías antes... mándame un solo correo. Te devolveré tus
            $11.99 de inmediato y te quedarás con todo el material.{' '}
            <span className="text-[#d4a853] font-semibold" data-id="element-62">
              Así de seguro estoy de lo que he creado.
            </span>
          </p>
        </div>
      </div>
    </AnimatedSection>;
}